import sistema from "./sistema/SICUS";
import funcion from "./funcion/funcion";
import catalogos from "./catalogos/catalogo";

const SICUS = {
  sistema, 
  funcion,
  catalogos
}

export default SICUS


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICUS/sicusapi.js
// module id = null
// module chunks = 